/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_AwardDocument_AwardDocument } from '../models/Wealthlane_AwardService_AwardDocument_AwardDocument';
import type { Wealthlane_AwardService_Dtos_AwardDocumentDto_DocumentDownloadDto } from '../models/Wealthlane_AwardService_Dtos_AwardDocumentDto_DocumentDownloadDto';
import type { Wealthlane_AwardService_Dtos_AwardDocumentDto_EditAwardDocumentDto } from '../models/Wealthlane_AwardService_Dtos_AwardDocumentDto_EditAwardDocumentDto';
import type { Wealthlane_AwardService_Dtos_AwardDocumentDto_EditEffectiveDateDto } from '../models/Wealthlane_AwardService_Dtos_AwardDocumentDto_EditEffectiveDateDto';
import type { Wealthlane_AwardService_Dtos_AwardDocumentDto_PublishAwardDocument } from '../models/Wealthlane_AwardService_Dtos_AwardDocumentDto_PublishAwardDocument';
import type { Wealthlane_AwardService_Dtos_Common_SampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_Common_SampleFileBlobDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AwardAgreementDocumentImportService {
  /**
   * @param issuanceId
   * @param baseUrl
   * @param endpointValue
   * @param ticker
   * @returns string OK
   * @throws ApiError
   */
  public static postApiAwardApiAppAwardAgreementDocumentImportParseUrl(
    issuanceId: string,
    baseUrl?: string,
    endpointValue?: string,
    ticker?: string
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/award-agreement-document-import/parse-url/{IssuanceId}',
      path: {
        IssuanceId: issuanceId,
      },
      query: {
        baseUrl: baseUrl,
        endpointValue: endpointValue,
        ticker: ticker,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @returns Wealthlane_AwardService_Dtos_Common_SampleFileBlobDto OK
   * @throws ApiError
   */
  public static postApiAwardApiAppAwardAgreementDocumentImportDownloadExternalTransactionImportSample(): CancelablePromise<Wealthlane_AwardService_Dtos_Common_SampleFileBlobDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/award-agreement-document-import/download-external-transaction-import-sample',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param formData
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
   * @throws ApiError
   */
  public static postApiAwardApiAppAwardAgreementDocumentImportImportAwardAgreementDocument(formData?: {
    File: Blob;
    ZipFile: Blob;
  }): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/award-agreement-document-import/import-award-agreement-document',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param documentId
   * @returns Wealthlane_AwardService_Dtos_AwardDocumentDto_DocumentDownloadDto OK
   * @throws ApiError
   */
  public static postApiAwardApiAppAwardAgreementDocumentImportDownloadAwardDocuments(
    documentId: string
  ): CancelablePromise<Wealthlane_AwardService_Dtos_AwardDocumentDto_DocumentDownloadDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/award-agreement-document-import/download-award-documents/{documentId}',
      path: {
        documentId: documentId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
   * @throws ApiError
   */
  public static postApiAwardApiAppAwardAgreementDocumentImportPublishAwardDocument(
    requestBody?: Wealthlane_AwardService_Dtos_AwardDocumentDto_PublishAwardDocument
  ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/award-agreement-document-import/publish-award-document',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
   * @throws ApiError
   */
  public static postApiAwardApiAppAwardAgreementDocumentImportEditEffectiveDate(
    requestBody?: Wealthlane_AwardService_Dtos_AwardDocumentDto_EditEffectiveDateDto
  ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/award-agreement-document-import/edit-effective-date',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
   * @throws ApiError
   */
  public static postApiAwardApiAppAwardAgreementDocumentImportEditAwardDocument(
    requestBody?: Array<Wealthlane_AwardService_Dtos_AwardDocumentDto_EditAwardDocumentDto>
  ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/award-agreement-document-import/edit-award-document',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postApiAwardApiAppAwardAgreementDocumentImportValidateDocumentPermissions(
    requestBody?: Wealthlane_AwardService_AwardDocument_AwardDocument
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/award-agreement-document-import/validate-document-permissions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
